
(function(){
  const html = document.documentElement;
  const modal = document.getElementById('measureGuideModal');
  const openBtn = document.getElementById('measureGuideBtn');

  if (!modal || !openBtn) return;

  const open = () => {
    html.classList.add('measure-modal-open');
    modal.style.display = 'block';
    modal.setAttribute('aria-hidden','false');
  };

  const close = () => {
    html.classList.remove('measure-modal-open');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden','true');
  };

  openBtn.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    open();
  });

  // close button inside modal
  modal.addEventListener('click', function(e){
    if (e.target.closest('.measure-close')) close();
    // click outside panel closes (optional)
    if (e.target === modal) close();
  });

  // ESC closes
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && modal.style.display !== 'none') close();
  });
})();

